var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.503 3.08465L3.93741 4.59403L2.42804 12.1597C2.40439 12.2805 2.41083 12.4052 2.4468 12.5229C2.48277 12.6407 2.54716 12.7477 2.63429 12.8347L12.4218 22.6222C12.4908 22.6927 12.5732 22.7488 12.6641 22.7871C12.7551 22.8254 12.8528 22.8451 12.9515 22.8451C13.0502 22.8451 13.1479 22.8254 13.2388 22.7871C13.3298 22.7488 13.4122 22.6927 13.4812 22.6222L21.9655 14.1378C22.0361 14.0688 22.0922 13.9864 22.1305 13.8954C22.1688 13.8045 22.1885 13.7068 22.1885 13.6081C22.1885 13.5094 22.1688 13.4117 22.1305 13.3207C22.0922 13.2298 22.0361 13.1474 21.9655 13.0784L12.178 3.2909C12.0911 3.20378 11.984 3.13938 11.8663 3.10342C11.7486 3.06745 11.6238 3.061 11.503 3.08465V3.08465Z",
    stroke: "#5A5B5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 8.53162C8.9375 9.11842 8.4618 9.59412 7.875 9.59412C7.2882 9.59412 6.8125 9.11842 6.8125 8.53162C6.8125 7.94481 7.2882 7.46912 7.875 7.46912C8.4618 7.46912 8.9375 7.94481 8.9375 8.53162Z",
    fill: "#5A5B5D",
    stroke: "#5A5B5D",
    strokeWidth: 0.125
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.e836e74bcdcb03bb0edfaa50ff598738.svg";
export { ForwardRef as ReactComponent };